import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { QUIZ_PROGRESS_FEATURE_KEY } from './keys';
import { quizProgressReducer } from './reducers/quiz-progress.reducer';
import { QuizProgressEffects } from './effects/quiz-progress.effects';
import { QuizProgress_ProgressBridge } from './bridge';

export const quizProgressStoreProviders = [
    provideState(QUIZ_PROGRESS_FEATURE_KEY, quizProgressReducer),
    provideEffects(QuizProgressEffects, QuizProgress_ProgressBridge),
];

export { QuizProgressFacade } from './facades/quiz-progress.facade';
export { quizProgressLoaded } from './guards/loaded.guard';
export { quizProgressCleanup } from './guards/cleanup.guard';
export { QuizProgress, Answer } from './models';
export { quizProgressActions } from './actions/quiz-progress.actions';
